import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataNn from './phonics/phonics_data_nn';

function PhonicsNn() {
  return <PhonicsAtoZ letterData={letterDataNn} />;
}

export default PhonicsNn;
